import posthog from 'posthog-js';

// Clé API PostHog (à mettre dans .env)
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';

let isInitialized = false;

export const initPostHog = () => {
  if (isInitialized || !POSTHOG_KEY) {
    if (!POSTHOG_KEY) {
      console.warn('PostHog key not configured');
    }
    return;
  }

  if (typeof window !== 'undefined') {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      // Désactiver l'autocapture pour plus de contrôle
      autocapture: false,
      // Capturer les clics sur les boutons
      capture_clicks: true,
      // Capturer les soumissions de formulaires
      capture_forms: true,
      // Respecter le Do Not Track
      respect_dnt: true,
      // Personnaliser l'identité
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          posthog.debug();
        }
      }
    });
    
    isInitialized = true;
    console.log('PostHog initialized');
  }
};

export const posthogService = {
  // Track un événement personnalisé
  track: (eventName: string, properties?: Record<string, any>) => {
    if (isInitialized && typeof window !== 'undefined' && posthog) {
      posthog.capture(eventName, properties);
    }
  },

  // Identifier un utilisateur (optionnel, pour les utilisateurs connectés)
  identify: (userId: string, properties?: Record<string, any>) => {
    if (isInitialized && typeof window !== 'undefined' && posthog) {
      posthog.identify(userId, properties);
    }
  },

  // Réinitialiser l'identité (logout)
  reset: () => {
    if (isInitialized && typeof window !== 'undefined' && posthog) {
      posthog.reset();
    }
  },

  // Définir des propriétés utilisateur
  setPersonProperties: (properties: Record<string, any>) => {
    if (isInitialized && typeof window !== 'undefined' && posthog) {
      posthog.setPersonProperties(properties);
    }
  },

  // Définir des propriétés de session
  register: (properties: Record<string, any>) => {
    if (isInitialized && typeof window !== 'undefined' && posthog) {
      posthog.register(properties);
    }
  }
};
